export type CatalogPlan = {
  id: string;
  name: string;
  billing_interval: "monthly" | "annual" | null;
  price_primary: string;
  price_secondary: string | null;
  items: string[];
};
export function publicPlans(catalog: CatalogPlan[]) {
  return catalog
    .filter((plan) => plan.id !== "bavimail_administrator")
    .map((plan) => ({
      ...plan,
      billing_interval:
        plan.billing_interval ??
        (/per year/i.test(plan.price_secondary ?? "")
          ? "annual"
          : /per month/i.test(plan.price_secondary ?? "")
            ? "monthly"
            : null),
    }));
}
export function allowanceLabel(label: string) {
  return label
    .replace(/bavimail\s*·\s*/gi, "")
    .replace(/retained gb storages?/gi, "GB retained storage")
    .replace(/storage \(gb\)/gi, "GB storage");
}
